"use client";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { DeckResult } from "@/lib/queries/deckQueries";
import { cn } from "@/lib/utils";
import { useSignal } from "@preact-signals/safe-react";
import { Settings2, Trash } from "lucide-react";
import type React from "react";
import { DeleteDeckAlert } from "./DeleteDeckAlert";
import { ToggleBuiltButton } from "./ToggleBuiltButton";
import { VisibilitySubMenu } from "./VisibilitySubMenu";

interface Props {
	deck: DeckResult;
}

export const DeckCardActions: React.FC<Props> = ({ deck }) => {
	const openSignal = useSignal(false);
	const deleteDeckSignal = useSignal(false);

	const openDeleteDeck = (e: React.MouseEvent) => {
		e.stopPropagation();
		deleteDeckSignal.value = true;
	};

	return (
		<div
			className={cn(
				"absolute bottom-0 left-0 right-0",
				"backdrop-blur-sm",
				"md:opacity-0",
				"group-hover:opacity-100",
				"group-focus-within:opacity-100",
				openSignal.value && "opacity-100",
			)}
			style={openSignal.value ? { opacity: 1 } : undefined}
		>
			<DropdownMenu
				open={openSignal.value}
				onOpenChange={(open) => {
					openSignal.value = open;
				}}
			>
				<DropdownMenuTrigger asChild>
					<Button
						className="w-full rounded-t-none"
						variant="ghost"
						onClick={(e) => e.stopPropagation()}
					>
						<Settings2 />
						Settings
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent>
					<ToggleBuiltButton deckId={deck.id} built={deck.built} />
					<VisibilitySubMenu deck={deck} />
					<DropdownMenuSeparator />
					<DropdownMenuItem
						className="text-destructive"
						onClick={openDeleteDeck}
					>
						<Trash className="mr-2 h-4 w-4" />
						Delete deck
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<DeleteDeckAlert deck={deck} openSignal={deleteDeckSignal} />
		</div>
	);
};
